import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/rubInCircleFilled.svg';

export const IconRubInCircleFilled = createIconComponent(Icon);
